import {Output, Component, EventEmitter, Input} from 'angular2/core';

/*
 This is a generic component to display submit button for form.
 This component provides a method to toggle a spinner, to inform user that actions is running.
 */

@Component({
    selector: "submit-button",
    template: `<button (click)='handleSubmit()' class='btn btn-primary btn-arrow-right' [disabled]='submitted' id="submitButton">
                    <ng-content></ng-content>
                    <i *ngIf="submitted" class='fa fa-spinner fa-spin' id='submitSpinner'></i>
                </button>`
})

export class SubmitButtonComponent {
    @Output()
    onSubmit:EventEmitter<any> = new EventEmitter<any>();
    submitted:boolean;

    constructor() {
        this.submitted = false;
    }

    handleSubmit() {
        this.onSubmit.emit(null);
    }

    public toggleSpinner() {
        this.submitted = !this.submitted;
    }
}
